<section class="business-registration-ads-quickly-5-steps">
  <div class="box-container">
    <div class="partner-topic">
      <h2 class="partner-topic__heading partner-topic__heading color-gray"
        >{{ 'BUSINESS_REGISTRATION_ADS.QUICKLY_5_STEPS.TITLE' | translate }}
      </h2>
      <div class="partner-topic__heading-detail">
        {{ 'BUSINESS_REGISTRATION_ADS.QUICKLY_5_STEPS.DETAIL' | translate }}
      </div>
    </div>
    <div class="box">
      <div class="box__left">
        <picture>
          <source
            srcset="https://flowaccountcdn.com/new_landing/image/functions/business/business_step5_v1.webp"
            type="image/webp"
          />
          <img
            src="https://flowaccountcdn.com/new_landing/image/functions/business/business_step5_v2.png"
            width="100%"
            loading="lazy"
            [alt]="'BUSINESS_REGISTRATION_ADS.QUICKLY_5_STEPS.TITLE' | translate"
            class="box__image"
          />
        </picture>
      </div>
      <div class="box__right">
        <ng-container *ngFor="let item of loopArray(5); let i = index">
          <div class="box__item">
            <div class="box__item--heading color-gray"
              ><span>{{ 'BUSINESS_REGISTRATION_ADS.QUICKLY_5_STEPS.' + (i + 1) + '.TITLE' | translate }}</span>
            </div>
            <div
              class="box__item--detail"
              [innerHtml]="'BUSINESS_REGISTRATION_ADS.QUICKLY_5_STEPS.' + (i + 1) + '.DETAIL' | translate"
            >
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
